import {RouteConfig} from 'vue-router'
import {MenuItem} from '@/store/types'

/**
 * Rutas del módulo
 */
export function routes (): RouteConfig[] {
    return [
        {
            name: 'calendar',
            path: '/calendario',
            component: () => import('@/modules/calendar/components/Calendar.vue'),
            meta: {
                authRequired: true,
                toolbarTitle: 'Calendario',
                module: 'calendar',
                vuex: {
                    loadModules: ['calendar'],
                },
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Calendario',
            routeName: 'calendar',
            module: 'calendar',
            icon: 'mdi-calendar',
            requireAuthorization: true,
            permission: '@/calendar/admin',
        },
    ]
}
